var Main = function(game){

};

var score = 0;

Main.prototype = {

	create: function() {
        
//        this.background = this.game.add.tileSprite(
//            0,
//            0,
//            this.game.width,
//            this.game.height,
//            "sky"
//          );
//          this.background.fixedToCamera = true;
          

		this.tileVelocity = -450;
        this.cloudVelocity = -150;
		this.rate = 1500;
        this.cloudRate =2500;
		score = 0;
        
        game.paused = true;
        
        
		this.tileWidth = this.game.cache.getImage('tile').width;
		this.tileHeight = this.game.cache.getImage('tile').height;
        this.wavesWidth = this.game.cache.getImage('waves').width;
        this.wavesHeight = this.game.cache.getImage('waves').height;
		this.boxHeight = this.game.cache.getImage('box').height;
        this.cloudHeight = this.game.cache.getImage('cloud1').height;
        this.cloudWidth = this.game.cache.getImage('cloud1').width;
        
        

		this.game.stage.backgroundColor = '#ffffff';
		

		this.game.physics.startSystem(Phaser.Physics.ARCADE);

		this.floor = this.game.add.group();
		this.floor.enableBody = true;
		this.floor.createMultiple(Math.ceil(this.game.world.width / this.tileWidth), 'tile');
        

		this.boxes = this.game.add.group();
		this.boxes.enableBody = true;
		this.boxes.createMultiple(20, 'shark');
		
        
        this.bottles = this.game.add.group();
		this.bottles.enableBody = true;
		this.bottles.createMultiple(20, 'bottle');
        
        this.buoy = this.game.add.group();
		this.buoy.enableBody = true;
		this.buoy.createMultiple(20, 'buoy');
        
        
        this.clouds = this.game.add.group();
		this.clouds.enableBody = true;
		this.clouds.createMultiple(25, 'cloud1');
        
        this.clouds2 = this.game.add.group();
		this.clouds2.enableBody = true;
		this.clouds2.createMultiple(25, 'cloud2');
		this.game.world.bringToTop(this.clouds)
        this.game.world.bringToTop(this.floor)

		this.jumping = false;
		this.addBase();
		this.createScore();
        this.showTitle();
      	this.showDirections();
		this.createPlayer();
        this.createWaves();
        this.createWaves2();
        this.createWaves3();
        this.createWaves4();
        if (screen.width > 1900) {
			this.createWaves5();
            this.createWaves6();
            this.createWaves7();
        }
		this.cursors = this.game.input.keyboard.createCursorKeys(); 

		this.timer = game.time.events.loop(2500, this.addObstacles, this);
        this.timer2 = game.time.events.loop(4000, this.addObstacles2, this);
        this.timer3 = game.time.events.loop(7000, this.addObstacles3, this);
        this.timer4 = game.time.events.loop(15000, this.addBuoys, this);
        this.clouder = game.time.events.loop(4500, this.addClouds2, this);
        this.clouder2 = game.time.events.loop(6000, this.addClouds, this);
        this.clouder3 = game.time.events.loop(7500, this.addClouds3, this);
		this.Scoretimer = game.time.events.loop(100, this.incrementScore, this);
      
      	
        
        //this.game.quit = this.game.input.keyboard.addKey(Phaser.Keyboard.ESC);
        
        this.game.input.onDown.add(function() {
            if (this.game.paused) {this.game.paused = false; this.gameTitle.destroy(); this.gameDirections.destroy();}
        }, this);
 

	},

	update: function() {

		this.game.physics.arcade.collide(this.player, this.floor);
		this.game.physics.arcade.collide(this.player, this.boxes, this.gameOver, null, this);
        this.game.physics.arcade.collide(this.player, this.buoy, this.gameOver, null, this);
        this.game.physics.arcade.collide(this.player, this.bottles, this.gameOver, null, this);

		var onTheGround = this.player.body.touching.down;

		// If the player is touching the ground, let him have 2 jumps
		if (onTheGround) {
			this.jumps = 2;
			this.jumping = false;
		}

		// Jump!
		if (this.jumps > 0 && this.upInputIsActive(5)) {
			this.player.body.velocity.y = -900;
			this.jumping = true;
		}

		// Reduce the number of available jumps if the jump input is released
		if (this.jumping && this.upInputReleased()) {
			this.jumps--;
			this.jumping = false;
		}
       

	},

	addBox: function (x, y) {

		var tile = this.boxes.getFirstDead();

		tile.reset(x, y);
		tile.body.velocity.x = this.tileVelocity;
		tile.body.immovable = true;
		tile.checkWorldBounds = true;
		tile.outOfBoundsKill = true;
		// tile.body.friction.x = 1000;
	},

	addObstacles: function () {
		var tilesNeeded = Math.floor( Math.random() * (2 - 0));
		// var gap = Math.floor( Math.random() * (tilesNeeded - 0));
		if (this.rate > 200) {
			this.rate -= 10;
			this.tileVelocity = -(675000 / this.rate);

		}

		for (var i = 0; i < tilesNeeded; i++) {
          
          if (screen.width < 1281 && screen.width > 900){
            this.addBox(this.game.world.width , this.game.world.height - 
				 this.tileHeight - 70);
          }
          else {
			this.addBox(this.game.world.width , this.game.world.height - 
				this.tileHeight - 120);
          }
          

		}
	},
    addBottles: function (x, y) {

		var tile = this.bottles.getFirstDead();

		tile.reset(x, y);
		tile.body.velocity.x = this.tileVelocity;
		tile.body.immovable = true;
		tile.checkWorldBounds = true;
		tile.outOfBoundsKill = true;
		// tile.body.friction.x = 1000;
	},

	addObstacles2: function () {
		var tilesNeeded = Math.floor( Math.random() * (2 - 0));
		// var gap = Math.floor( Math.random() * (tilesNeeded - 0));
		if (this.rate > 200) {
			this.rate -= 10;
			this.tileVelocity = -(675000 / this.rate);

		}

		for (var i = 0; i < tilesNeeded; i++) {
          
          if (screen.width < 1281 && screen.width > 900){
            this.addBottles(this.game.world.width , this.game.world.height - 
				this.tileHeight - 60);
          }
          else{
			this.addBottles(this.game.world.width , this.game.world.height - 
				this.tileHeight - 100);
          }

		}
	},
    
    addBuoys: function (x, y) {

		var tile = this.buoy.getFirstDead();

		tile.reset(x, y);
		tile.body.velocity.x = this.tileVelocity;
		tile.body.immovable = true;
		tile.checkWorldBounds = true;
		tile.outOfBoundsKill = true;
		// tile.body.friction.x = 1000;
	},

	addObstacles3: function () {
		var tilesNeeded = Math.floor( Math.random() * (2 - 0));
		// var gap = Math.floor( Math.random() * (tilesNeeded - 0));
		if (this.rate > 200) {
			this.rate -= 10;
			this.tileVelocity = -(675000 / this.rate);

		}

		for (var i = 0; i < tilesNeeded; i++) {

		  if (screen.width < 1281 && screen.width > 900){
            this.addBuoys(this.game.world.width , this.game.world.height - 
				 this.tileHeight - 40);
          }
          else {
			this.addBuoys(this.game.world.width , this.game.world.height - 
				this.tileHeight - 50);
          }

		}
	},
    
    
    addCloud: function (x, y) {

		var cloud = this.clouds.getFirstDead();

		cloud.reset(x, y);
		cloud.body.velocity.x = this.cloudVelocity;
		cloud.body.immovable = true;
		cloud.checkWorldBounds = true;
		cloud.outOfBoundsKill = true;
		// tile.body.friction.x = 1000;
	},

	addClouds: function () {
		var tilesNeeded = Math.floor( Math.random() * (2 - 0));
		if (this.cloudRate > 200) {
			this.cloudVelocity = -(300000 / this.cloudRate);

		}

		for (var i = 0; i < tilesNeeded; i++) {

			this.addCloud(this.game.world.width , this.game.world.height - 
				this.tileHeight - ((i + 1)* this.cloudHeight + this.game.world.height / 3));

		}
	},
    
    addCloud2: function (x, y) {

		var cloud = this.clouds.getFirstDead();

		cloud.reset(x, y);
		cloud.body.velocity.x = this.cloudVelocity;
		cloud.body.immovable = true;
		cloud.checkWorldBounds = true;
		cloud.outOfBoundsKill = true;
		// tile.body.friction.x = 1000;
	},

	addClouds2: function () {
		var tilesNeeded = Math.floor( Math.random() * (2 - 0));
		if (this.rate > 200) {
			this.tileVelocity = -(675000 / this.rate);

		}

		for (var i = 0; i < tilesNeeded; i++) {

			this.addCloud(this.game.world.width , this.game.world.height - 
				this.tileHeight - ((i + 1)* this.cloudHeight + this.game.world.height / 4));

		}
	},
    
    addCloud3: function (x, y) {

		var cloud = this.clouds.getFirstDead();

		cloud.reset(x, y);
		cloud.body.velocity.x = this.cloudVelocity;
		cloud.body.immovable = true;
		cloud.checkWorldBounds = true;
		cloud.outOfBoundsKill = true;
		// tile.body.friction.x = 1000;
	},

	addClouds3: function () {
		var tilesNeeded = Math.floor( Math.random() * (2 - 0));
		if (this.rate > 200) {
			this.tileVelocity = -(675000 / this.rate);

		}

		for (var i = 0; i < tilesNeeded; i++) {

			this.addCloud(this.game.world.width , this.game.world.height - 
				this.tileHeight - ((i + 1)* this.cloudHeight + this.game.world.height / 5));

		}
	},

	addTile: function (x, y) {

		var tile = this.floor.getFirstDead();

		tile.reset(x, y);
		// tile.body.velocity.y = me.vel;
		tile.body.immovable = true;
		tile.checkWorldBounds = true;
		tile.outOfBoundsKill = true;
		// tile.body.friction.x = 1000;
	},

	addBase: function () {
		var tilesNeeded = Math.ceil(this.game.world.width / this.tileWidth);
      	
		var y = (this.game.world.height - this.tileHeight);

		for (var i = 0; i < tilesNeeded; i++) {

			this.addTile(i * this.tileWidth, y);

		}
	},

	upInputIsActive: function (duration) {
		var isActive = false;
      
		isActive = this.input.keyboard.downDuration(Phaser.Keyboard.UP, duration);
      	if (screen.width > 900){
		isActive |= (this.game.input.activePointer.justPressed(duration + 1000 /60) &&
			this.game.input.activePointer.x > this.game.width / 4 &&
			this.game.input.activePointer.x < this.game.width / 2 + this.game.width / 4);
        }
      	if (screen.width < 900){
		isActive |= (this.game.input.activePointer.justPressed(duration + 1000 /20) &&
			this.game.input.activePointer.x > this.game.width / 4 &&
			this.game.input.activePointer.x < this.game.width / 2 + this.game.width / 4);
        }
		return isActive;
	},

	// This function returns true when the player releases the "jump" control
	upInputReleased: function () {
		var released = false;

		released = this.input.keyboard.upDuration(Phaser.Keyboard.UP);
		released |= this.game.input.activePointer.justReleased();

		return released;
	},

	createPlayer: function () {

		this.player = this.game.add.sprite(this.game.world.width/5, this.game.world.height, 'player');
		this.player.scale.setTo(1, 1);
		this.player.anchor.setTo(0.5, 1.8);
		this.game.physics.arcade.enable(this.player);
		this.player.body.gravity.y = 1500;
		this.player.body.collideWorldBounds = false;
		this.player.body.bounce.y = .5;
		this.player.body.drag.x = 150;
		var walk = this.player.animations.add('walk');
		this.player.animations.play('walk', 4, true);
      	if (screen.width < 1281 && screen.width > 900){
          this.player.scale.setTo(.5, .5);
          this.player.anchor.setTo(0.5, 3);
          this.player.body.gravity.y = 2500;
          this.player.body.bounce.y = .25;
        }

	},
    
    createWaves: function () {
      
		if (screen.width < 1281 && screen.width > 900){
          this.waves = this.game.add.sprite(0, this.game.height - this.tileHeight, 'waves');
        }
      	else {
			this.waves = this.game.add.sprite(0, this.game.height - this.wavesHeight, 'waves');
        }
		this.game.physics.arcade.enable(this.waves);
		var bounce = this.waves.animations.add('bounce');
		this.waves.animations.play('bounce', 5, true);
      	this.game.world.bringToTop(this.waves)
        if (screen.width < 1281 && screen.width > 900){
          this.waves.scale.setTo(.5, .5);
        }
      	else {
          this.waves.scale.setTo(1, 1);
        }
	},
    createWaves2: function () {
      
      	if (screen.width < 1281 && screen.width > 900){
          this.waves2 = this.game.add.sprite(500, this.game.height - this.tileHeight, 'waves');
        }
      	else {
			this.waves2 = this.game.add.sprite(1000, this.game.height - this.wavesHeight, 'waves');
        }
		this.game.physics.arcade.enable(this.waves2);
		var bounce = this.waves2.animations.add('bounce');
		this.waves2.animations.play('bounce', 5, true);
        this.game.world.bringToTop(this.waves2)
        if (screen.width < 1281 && screen.width > 900){
          this.waves2.scale.setTo(.5, .5);
        }
      	else {
          this.waves2.scale.setTo(1, 1);
        }
	},
    createWaves3: function () {
      
      	if (screen.width < 1281 && screen.width > 900){
          this.waves3 = this.game.add.sprite(1000, this.game.height - this.tileHeight, 'waves');
        }
      	else {
			this.waves3 = this.game.add.sprite(2000, this.game.height - this.wavesHeight, 'waves');
        }

		this.game.physics.arcade.enable(this.waves3);
		var bounce = this.waves3.animations.add('bounce');
		this.waves3.animations.play('bounce', 5, true);
        this.game.world.bringToTop(this.waves3)
        if (screen.width < 1281 && screen.width > 900){
          this.waves3.scale.setTo(.5, .5);
        }
      	else {
          this.waves3.scale.setTo(1, 1);
        }
	},
    createWaves4: function () {

		this.waves4 = this.game.add.sprite(3000, this.game.height - this.wavesHeight, 'waves');
		this.game.physics.arcade.enable(this.waves4);
		var bounce = this.waves4.animations.add('bounce');
		this.waves4.animations.play('bounce', 5, true);
        this.game.world.bringToTop(this.waves4)
        if (screen.width < 1281 && screen.width > 900){
          this.waves4.scale.setTo(.5, .5);
        }
	},
  	createWaves5: function () {

		this.waves5 = this.game.add.sprite(4000, this.game.height - this.wavesHeight, 'waves');
		this.game.physics.arcade.enable(this.waves5);
		var bounce = this.waves5.animations.add('bounce');
		this.waves5.animations.play('bounce', 5, true);
        this.game.world.bringToTop(this.waves5)
	},
  	createWaves6: function () {

		this.waves6 = this.game.add.sprite(5000, this.game.height - this.wavesHeight, 'waves');
		this.game.physics.arcade.enable(this.waves6);
		var bounce = this.waves6.animations.add('bounce');
		this.waves6.animations.play('bounce', 5, true);
        this.game.world.bringToTop(this.waves6)
	},
  	createWaves7: function () {

		this.waves7 = this.game.add.sprite(6000, this.game.height - this.wavesHeight, 'waves');
		this.game.physics.arcade.enable(this.waves7);
		var bounce = this.waves7.animations.add('bounce');
		this.waves4.animations.play('bounce', 7, true);
        this.game.world.bringToTop(this.waves4)
	},

	createScore: function () {
		if (screen.width > 900) {
          var scoreFontLarge = "72px mega2";
        }
      	if (screen.width < 900) {
          var scoreFontLarge = "60px mega2";
        }
      	if (screen.width < 1281 && screen.width > 900){
          var scoreFontLarge = "30px mega2";
        }
        

		this.scoreLabel = this.game.add.text(this.game.world.centerX, this.game.world.centerY / 1.2, "", { font: scoreFontLarge, fill: "#000" });
      	if (screen.width > 900) {
			this.scoreLabel.anchor.setTo(0.5, 0);
        }
      	if (screen.width < 900) {
			this.scoreLabel.anchor.setTo(0.5, 0);
        }
		this.scoreLabel.align = 'center';
		this.game.world.bringToTop(this.scoreLabel);
        

		/*this.highScore = this.game.add.text(this.game.world.centerX * 1.7, 120, "0", { font: scoreFontSmall, fill: "#000" });
		this.highScore.anchor.setTo(0.5, -.5);
		this.highScore.align = 'right';
		this.game.world.bringToTop(this.highScore);

		if (window.localStorage.getItem('HighScore') == null) {
			this.highScore.setText(0);
			this.highScore.setText("Highscore:  " + window.localStorage.setItem('HighScore', 0));
		}
		else {
			this.highScore.setText("Highscore:  " + window.localStorage.getItem('HighScore'));
		}*/
		// this.scoreLabel.bringToTop()

	},

	incrementScore: function () {


		score += 1;
		this.scoreLabel.setText(score);
		this.game.world.bringToTop(this.scoreLabel);
		//this.highScore.setText("Highscore:  " + window.localStorage.getItem('HighScore'));
		//this.game.world.bringToTop(this.highScore);


	},
    
    showTitle: function() {
      	if (screen.width > 900) {
          var titleFont = "32px mega";
        }
      	if (screen.width < 900) {
          var titleFont = "32px mega";
        }
      	if (screen.width < 1281 && screen.width > 900){
          var titleFont = "20px mega";
        }
        
        this.username = window.localStorage.getItem('userName');
        
        this.gameTitle = this.game.add.text(this.game.world.centerX
			, this.game.world.centerY / 1.4, "", { font: titleFont, fill: "#000" });
      	if (this.username != null){
        	this.gameTitle.anchor.setTo(0.5, 0);
        }
      	else if(this.username === null) {
        	this.gameTitle.anchor.setTo(0.5, 0);
      	}	
      	if (screen.width < 1281 && screen.width > 900){
          this.gameTitle.anchor.setTo(0.5, 0);
        }
        this.gameTitle.align = 'center';
        this.game.world.bringToTop(this.gameTitle);
        if (this.username != null && screen.width > 900){
        	this.gameTitle.text = ("\n CLICK     TO     START ");
        }
      	else if (this.username != null && screen.width < 900){
        	this.gameTitle.text = ("\n TAP     TO     START");
        }
      	else if (this.username === null && screen.width > 900){
        	this.gameTitle.text = ("\n CREATE     A    USERNAME     THEN     CLICK     TO     START");
        }
      	else if (this.username === null && screen.width < 900){
        	this.gameTitle.text = ("\n TAP   TO   START");
        }
        
    },
  
  	showDirections: function() {
      	if (screen.width > 900) {
          var directionFont = "32px mega";
        }
      	if (screen.width < 900) {
          var directionFont = "32px mega";
        }
      	if (screen.width < 1281 && screen.width > 900){
          var directionFont = "20px mega";
        }
        this.username = window.localStorage.getItem('userName');
        
        this.gameDirections = this.game.add.text(this.game.world.centerX
			, this.game.world.centerY / 1.3, "", { font: directionFont, fill: "#000" });
        if (this.username != null){
        	this.gameDirections.anchor.setTo(0.5, -1);
        }
      	else{
        	this.gameDirections.anchor.setTo(0.5, -1);
      	}
        this.gameDirections.align = 'center';
        this.game.world.bringToTop(this.gameDirections);
      	if (this.username != null && screen.width > 900){
        	this.gameDirections.text = ("\n USE     UP     ARROW    TO     JUMP");
        }
      	else if (this.username != null && screen.width < 900){
        	this.gameDirections.text = ("\n TAP    TO     JUMP");
          	//this.gameDirections.anchor.setTo(0.5, -3);
        }
      	else if (this.username === null && screen.width > 900){
        	this.gameDirections.text = ("\n USE     UP     ARROW    TO     JUMP");
        }
      	else if (this.username === null && screen.width < 900){
        	this.gameDirections.text = ("\n TAP    TO     JUMP");
          	//this.gameDirections.anchor.setTo(0.5, -3);
        }

        
        
    },
    
    showScore: function () {
        if (screen.width > 900) {
          var scoreFont = "90px mega2";
          var scoreFontSmall = "36px mega2";
        }
      	if (screen.width < 900) {
          var scoreFont = "40px mega2";
          var scoreFontSmall = "30px mega2";
        }
      	if (screen.width < 1281 && screen.width > 900){
          var scoreFont = "24px mega2";
          var scoreFontSmall = "18px mega2";
        }

      	if (screen.width > 900) {
		this.scoreLabel2 = this.game.add.text(this.game.world.centerX
			, this.game.world.centerY, "0", { font: scoreFont, fill: "#000" });
        }
      	if (screen.width < 900) {
          this.scoreLabel2 = this.game.add.text(this.game.world.centerX
			, this.game.world.centerY / 1.5, "0", { font: scoreFont, fill: "#000" });
        }
		this.scoreLabel2.anchor.setTo(0.5, 0);
		this.scoreLabel2.align = 'center';
		this.game.world.bringToTop(this.scoreLabel2);
		this.scoreLabel2.text = ("Your   Score:   " + (score));
		
      
		this.highScore = this.game.add.text(this.game.world.centerX
			, this.game.world.centerY / 1.5, "0", { font: scoreFontSmall, fill: "#000" });
		this.highScore.anchor.setTo(0.5, 0.5);
		this.highScore.align = 'center';
		this.game.world.bringToTop(this.highScore);
      	if (screen.width < 900) {
          this.highScore.destroy();
        }
        
//        this.user = window.localStorage.getItem('Username');
//        
//        if (this.user == null) {
//			this.userName.setText(("Name:" + (score));
//			window.localStorage.setItem('Username', score)
//		}
//		else if (parseInt(this.hs) < score) {
//			this.highScore.setText("Score: " + (score));
//			window.localStorage.setItem('HighScore', score)
//
//		}
//		else {
//			this.highScore.setText("High  Score:   " + this.hs);
//		}

		this.hs = window.localStorage.getItem('HighScore');

		if (this.hs == null) {
			this.highScore.setText("Score:" + (score));
			window.localStorage.setItem('HighScore', score)
		}
		else if (parseInt(this.hs) < score) {
			this.highScore.setText("Score: " + (score));
			window.localStorage.setItem('HighScore', score)

		}
      	
		else {
			this.highScore.setText("Your  Best:   " + this.hs);
		}
		if (screen.width > 900) {
		this.restart = this.game.add.text(this.game.world.centerX
			, this.game.world.centerY * 1.4
			, "Click     to    Play    Again ", { font: scoreFontSmall, fill: "#000" });
        }
      	if (screen.width < 900) {
		this.restart = this.game.add.text(this.game.world.centerX
			, this.game.world.centerY 
			, "Tap    to    Play    Again ", { font: scoreFontSmall, fill: "#000" });
        }
		this.restart.anchor.setTo(0.5, 0);
		this.restart.align = 'center';
		this.game.world.bringToTop(this.restart);
		// this.scoreLabel.bringToTop()

	},

	restartGame: function(){
		this.game.state.start("Main");
	},

	gameOver: function(){
        this.showScore();
        this.player.animations.stop();
        this.player.body.gravity.y = 1500000000000;
        this.tileVelocity = 0;
        this.cloudVelocity = 0;
		this.rate = 0;
        this.cloudRate = 0;
        game.paused = true;
        this.game.state.start("Main");
        this.scoreLabel.destroy();
        this.player.loadTexture('xmark');

        //this.clouds.body.enable();
        //this.player.physics = false;
	},
    

};

/**
 * CanvasRenderingContext2D.renderText extension
 */
if (CanvasRenderingContext2D && !CanvasRenderingContext2D.renderText) {
    // @param  letterSpacing  {float}  CSS letter-spacing property
    CanvasRenderingContext2D.prototype.renderText = function (text, x, y, letterSpacing) {
        if (!text || typeof text !== 'string' || text.length === 0) {
            return;
        }
        
        if (typeof letterSpacing === 'undefined') {
            letterSpacing = 1;
        }
        
        // letterSpacing of 0 means normal letter-spacing
        
        var characters = String.prototype.split.call(text, ''),
            index = 0,
            current,
            currentPosition = x,
            align = 1;
        
        if (this.textAlign === 'right') {
            characters = characters.reverse();
            align = -1;
        } else if (this.textAlign === 'center') {
            var totalWidth = 0;
            for (var i = 0; i < characters.length; i++) {
                totalWidth += (this.measureText(characters[i]).width + letterSpacing);
            }
            currentPosition = x - (totalWidth / 2);
        }
        
        while (index < text.length) {
            current = characters[index++];
            this.fillText(current, currentPosition, y);
            currentPosition += (align * (this.measureText(current).width + letterSpacing));
        }
    }
}





  class PaginationInfinite extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
  }

  connectedCallback() {
    this.containerElement = document.getElementById("product-grid");
    this.paginationElement = document.querySelector("[data-pagination]");

    if (!this.paginationElement) {
      return;
    }

    this.nextPageLinkElement = this.paginationElement.querySelector("a");

    if (this.nextPageLinkElement) {
      
      this.nextPageUrl = this.nextPageLinkElement.href;

      // Create an IntersectionObserver to load the next page when the bottom of the page is reached
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.loadNextPage();
          }
        });
      });

      this.observer.observe(this.paginationElement);
    }
  }

  loadNextPage() {
    if (!this.nextPageUrl) return;

    this.nextPageLinkElement.classList.add("loading");
    this.nextPageLinkElement
      .querySelector(".loading-overlay__spinner")
      .classList.remove("hidden");

    this.request = new XMLHttpRequest();
    this.request.onreadystatechange = () => {
      if (this.request.readyState === XMLHttpRequest.DONE) {
        if (this.request.status === 200) {
          var newDocument = this.request.responseXML;
          if (newDocument) {
            var newContainer = newDocument.getElementById("product-grid");
            var newPagination = newDocument.querySelector("[data-pagination]");

            if (newContainer) {
              this.containerElement.insertAdjacentHTML(
                "beforeend",
                newContainer.innerHTML
              );

              // Query the newly added elements
              var newElements = this.containerElement.querySelectorAll(
                ".block-variant__card .available"
              );
              newElements.forEach((element) => {
                // Perform operations on the newly added elements
                element.addEventListener("click", (e) => {
                  const clickedVariantId =
                    e.currentTarget.getAttribute("data-value");
                  e.currentTarget
                    .closest(".card-variant-picker")
                    .querySelector("input[name='id']").value = clickedVariantId;
                  e.currentTarget
                    .closest(".card-variant-picker")
                    .querySelector("button.product-form__submit")
                    .click();
                });
              });
            }
            this.nextPageLinkElement.classList.remove("loading");
            this.nextPageLinkElement
              .querySelector(".loading-overlay__spinner")
              .classList.add("hidden");

            if (newPagination) {
              let url = newPagination.querySelector("a")?.getAttribute("href");
              if (url) {
                this.nextPageUrl = url;
              } else {
                this.nextPageUrl = null;
                this.paginationElement.innerHTML = "";
                this.observer.disconnect();
              }
            } else {
              this.nextPageUrl = null;
              this.paginationElement.innerHTML = "";
              this.observer.disconnect();
            }
          }
        } else {
          console.error("Error loading new page:", this.request.status);
          this.nextPageLinkElement.classList.remove("loading");
          this.nextPageLinkElement
            .querySelector(".loading-overlay__spinner")
            .classList.add("hidden");
        }
      }
    };

    this.request.open("GET", this.nextPageUrl);
    this.request.responseType = "document";
    this.request.send();
    
  }
}

customElements.define("pagination-infinite", PaginationInfinite);
